import classes from './Paragraph.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  variant?: '' |
  'text-overflow' |
  'word-break'|
  'whitespace-pre-wrap'
}

const Paragraph = ({
  children,
  variant = ''
}: Props) => {
  const paragraphClasses = [
    classes.Paragraph,
    classes[variant]
  ].filter(classname => classname).join(' ')

  return (
    <p className={paragraphClasses}>
      {children}
    </p>
  )
}

export default Paragraph
